/**
 * 该文件主要用于店铺装修主题
 */

export const THEME_WHITE_RED = 0
export const THEME_WHITE_GOLD = 1
export const THEME_BLACK_GOLD = 2
export const THEME_WHITE_GREEN = 3
export const THEME_WHITE_BLUE = 4
export const THEME_WHITE_PINK = 5
export const THEME_TOP_WEDDING = 6

// 文字颜色
const DEFAULT_TEXT_COLOR = '#666'
const BLACK_GOLD_TEXT_COLOR = '#d5c8b4'

// 整个背景
const BG_COLOR = '#eee'
const BG_BLACK_GOLD_COLOR = '#2d2c2a'

// 每块背景
const BLOCK_BG_COLOR = '#fff'
const BLOCK_BG_BLACK_GOLD_COLOR = '#242321'

// 分割线颜色
const LINE = '#eee'
const BLACK_GOLD_LINE = '#3e3d3a'

// 金色
export const GOLD_COLOR = '#d29c44'

// 默认
export const THEME_RED_COLOR = '#f83244'
// 典雅白（白金）
export const THEME_WHITE_COLOR = '#d29c44'
// 尊贵黑（黑金）
export const THEME_BLACK_COLOR = '#d5c8b4'
// 清新绿
export const THEME_GREEN_COLOR = '#2fc07a'
// 雅典蓝
export const THEME_BLUE_COLOR = '#3ea2ea'
// 樱花粉
export const THEME_PINK_COLOR = '#ff7894'
// 彩色版辅助颜色（用于套餐字体等）
export const THEME_HELP_COLOR = '#ff801a'

/**
 * theme
 * text，随主题变换成的字体颜色
 * defaultText，默认字体颜色
 * line, 分割线颜色
 * homeBg，整个装修区域背景色,
 * bg，每一块编辑区域背景色，
 * helper，彩色版辅助颜色
 * promiseIcon,商家承诺图标
 * positionIcon, 导航图标
 * nameIcon, 名称图标，
 * block, 块级背景色，
 * link，链接样式，暂时只用于加盟店 '查看更多' 文字
 * bondIcon，放心购图标
 */
export const THEME_COLOR = {
  [THEME_WHITE_RED]: {
    theme: THEME_RED_COLOR,
    text: THEME_RED_COLOR,
    defaultText: DEFAULT_TEXT_COLOR,
    line: LINE,
    homeBg: BG_COLOR,
    bg: BLOCK_BG_COLOR,
    helper: THEME_HELP_COLOR,
    teamMeal: '//qnm.hunliji.com/o_1ciorpebh13ldplk1sh5a3541hc.png',
    phone: '//qnm.hunliji.com/o_1cio8d8uo1bvv1bforpd2f411kl7.png',
    star: '//qnm.hunliji.com/o_1cio955vk1cs7p5618c63748s7.png',
    btn: 'linear-gradient(135deg, #ff5b6a 0%, #f83244 100%)',
    location: '//qnm.hunliji.com/o_1cio8hssc1ito1okh110ohcktpb7.png',
    promiseIcon: '//qnm.hunliji.com/o_1cn37t592i6s1tuh17841nc8ao49.png',
    positionIcon: '//qnm.hunliji.com/o_1cn1l46megjafrk1trs1okd11rtb.png',
    blockBg: '#FFECEC',
    blockText: THEME_RED_COLOR,
    nameIcon: '//qnm.hunliji.com/o_1cn1l46mfjse19sfj3t1jr9ogjd.png'
  },
  [THEME_WHITE_GOLD]: {
    theme: THEME_WHITE_COLOR,
    text: THEME_WHITE_COLOR,
    defaultText: DEFAULT_TEXT_COLOR,
    line: LINE,
    homeBg: BG_COLOR,
    bg: BLOCK_BG_COLOR,
    helper: GOLD_COLOR,
    teamMeal: '//qnm.hunliji.com/o_1cj527hfv9sh17qq6ub1i6j1llcd.png',
    phone: '//qnm.hunliji.com/o_1cj52eep0hm3lan10701cek1j92d.png',
    star: '//qnm.hunliji.com/o_1cj52jqvo5mtbbg1f4da1d1t6hd.png',
    btn: 'linear-gradient(135deg, #f5c77c 0%, #d29c44 100%)',
    location: '//qnm.hunliji.com/o_1cio8hssc1ito1okh110ohcktpb7.png',
    promiseIcon: '//qnm.hunliji.com/o_1cnjh7uje1ttqnlhb56ij4lb6f.png',
    positionIcon: '//qnm.hunliji.com/o_1cn1l46megjafrk1trs1okd11rtb.png',
    blockBg: GOLD_COLOR,
    nameIcon: '//qnm.hunliji.com/o_1cn1l46mfjse19sfj3t1jr9ogjd.png'
  },
  [THEME_BLACK_GOLD]: {
    theme: BLOCK_BG_BLACK_GOLD_COLOR,
    text: THEME_BLACK_COLOR,
    defaultText: BLACK_GOLD_TEXT_COLOR,
    line: BLACK_GOLD_LINE,
    homeBg: BG_BLACK_GOLD_COLOR,
    bg: BLOCK_BG_BLACK_GOLD_COLOR,
    helper: GOLD_COLOR,
    teamMeal: '//qnm.hunliji.com/o_1cj527hfv9sh17qq6ub1i6j1llcd.png',
    phone: '//qnm.hunliji.com/o_1cj52eep0hm3lan10701cek1j92d.png',
    star: '//qnm.hunliji.com/o_1cj52jqvo5mtbbg1f4da1d1t6hd.png',
    btn: 'linear-gradient(135deg, #f5c77c 0%, #d29c44 100%)',
    location: '//qnm.hunliji.com/o_1cj5f0ef51f9212nj1jtomud5rn7.png',
    promiseIcon: '//qnm.hunliji.com/o_1cnjh7uje1ttqnlhb56ij4lb6f.png',
    positionIcon: '//qnm.hunliji.com/o_1cn1l46megjafrk1trs1okd11rtb.png',
    nameIcon: '//qnm.hunliji.com/o_1cn1l46mfjse19sfj3t1jr9ogjd.png',
    blockBg: GOLD_COLOR,
    link: THEME_BLACK_COLOR
  },
  [THEME_TOP_WEDDING]: {
    theme: BLOCK_BG_BLACK_GOLD_COLOR,
    text: THEME_BLACK_COLOR,
    defaultText: BLACK_GOLD_TEXT_COLOR,
    line: BLACK_GOLD_LINE,
    homeBg: BG_BLACK_GOLD_COLOR,
    bg: BLOCK_BG_BLACK_GOLD_COLOR,
    helper: GOLD_COLOR,
    teamMeal: '//qnm.hunliji.com/o_1cj527hfv9sh17qq6ub1i6j1llcd.png',
    phone: '//qnm.hunliji.com/o_1cj52eep0hm3lan10701cek1j92d.png',
    star: '//qnm.hunliji.com/o_1cj52jqvo5mtbbg1f4da1d1t6hd.png',
    btn: 'linear-gradient(135deg, #f5c77c 0%, #d29c44 100%)',
    location: '//qnm.hunliji.com/o_1cj5f0ef51f9212nj1jtomud5rn7.png',
    promiseIcon: '//qnm.hunliji.com/o_1cnjh7uje1ttqnlhb56ij4lb6f.png',
    positionIcon: '//qnm.hunliji.com/o_1cn1l46megjafrk1trs1okd11rtb.png',
    nameIcon: '//qnm.hunliji.com/o_1cn1l46mfjse19sfj3t1jr9ogjd.png',
    blockBg: GOLD_COLOR,
    link: THEME_BLACK_COLOR
  },
  [THEME_WHITE_GREEN]: {
    theme: THEME_GREEN_COLOR,
    text: THEME_GREEN_COLOR,
    defaultText: DEFAULT_TEXT_COLOR,
    line: LINE,
    homeBg: BG_COLOR,
    bg: BLOCK_BG_COLOR,
    helper: THEME_HELP_COLOR,
    teamMeal: '//qnm.hunliji.com/o_1cj527hfv15g918le9tko3ss7b.png',
    phone: '//qnm.hunliji.com/o_1cj52eep01ccq1isd78d1bkqcojb.png',
    star: '//qnm.hunliji.com/o_1cj52jqvo1eat1eunhig18eqd1nb.png',
    btn: 'linear-gradient(135deg, #99de6f 0%, #98ce64 100%)',
    location: '//qnm.hunliji.com/o_1cio8hssc1ito1okh110ohcktpb7.png',
    promiseIcon: '//qnm.hunliji.com/o_1cnjh7ujek5u1341vco1vqs1lpfh.png',
    positionIcon: '//qnm.hunliji.com/o_1cnlkcqsps3114dj1vtp5511moea.png',
    blockBg: THEME_GREEN_COLOR,
    nameIcon: '//qnm.hunliji.com/o_1cnlkcqspf7kq2reric9318qeb.png'
  },
  [THEME_WHITE_BLUE]: {
    theme: THEME_BLUE_COLOR,
    text: THEME_BLUE_COLOR,
    defaultText: DEFAULT_TEXT_COLOR,
    line: LINE,
    homeBg: BG_COLOR,
    bg: BLOCK_BG_COLOR,
    helper: THEME_HELP_COLOR,
    teamMeal: '//qnm.hunliji.com/o_1cj527hfv90i1s891dr07nvcr4c.png',
    phone: '//qnm.hunliji.com/o_1cj52eep019dj4ra1jpl12jq1bqtc.png',
    star: '//qnm.hunliji.com/o_1cj52jqvo1hom169equ9jvb1r1ec.png',
    btn: 'linear-gradient(135deg, #48c1ff 0%, #3ea2ea 100%)',
    location: '//qnm.hunliji.com/o_1cio8hssc1ito1okh110ohcktpb7.png',
    promiseIcon: '//qnm.hunliji.com/o_1cnjh7uje12iu1tv342k1r1fonsg.png',
    positionIcon: '//qnm.hunliji.com/o_1cnlkcqsps3114dj1vtp5511moea.png',
    blockBg: THEME_BLUE_COLOR,
    nameIcon: '//qnm.hunliji.com/o_1cnlkcqspf7kq2reric9318qeb.png'
  },
  [THEME_WHITE_PINK]: {
    theme: THEME_PINK_COLOR,
    text: THEME_PINK_COLOR,
    defaultText: DEFAULT_TEXT_COLOR,
    line: LINE,
    homeBg: BG_COLOR,
    bg: BLOCK_BG_COLOR,
    helper: THEME_HELP_COLOR,
    teamMeal: '//qnm.hunliji.com/o_1cj527hfvfnavqelq71gsi1kana.png',
    phone: '//qnm.hunliji.com/o_1cj52eeov9ufich940ruj1jnfa.png',
    star: '//qnm.hunliji.com/o_1cj52jqvo39qo541s4d1o111ja4a.png',
    btn: 'linear-gradient(135deg, #ff98bf 0%, #ff7894 100%)',
    location: '//qnm.hunliji.com/o_1cio8hssc1ito1okh110ohcktpb7.png',
    promiseIcon: '//qnm.hunliji.com/o_1cnjh7uje1el66hp1odj1ooogtee.png',
    positionIcon: '//qnm.hunliji.com/o_1cnlkcqsps3114dj1vtp5511moea.png',
    blockBg: THEME_PINK_COLOR,
    nameIcon: '//qnm.hunliji.com/o_1cnlkcqspf7kq2reric9318qeb.png'
  }
}

/**
 * TODO，上面的太乱了，后续所有主题配置用这个
 * darkestText：默认主题时最深的文字色
 * darkerText: 默认主题时较深的文字色
 * text: 默认主题时的默认文字色
 * splitLine: 分割线，好像有两种
 * themeColor: 主题色本身的颜色，红、白金、黑金等
 */
export const NEW_THEME_CONFIG = {
  [THEME_WHITE_RED]: {
    darkestText: '#000',
    darkerText: '#333',
    text: '#666',
    moduleTitle: '#000',
    splitLine: '#e2e2e2',
    themeColor: '#F83244',
    moduleBg: BLOCK_BG_COLOR,
    honorIcon: '//qnm.hunliji.com/o_1cnjk7amfmm6kljsa910hd1q7hd.png',
    defaultStar: '//qnm.hunliji.com/o_1djrlk66r9ct10kolju1caa8k9.png',
    coverStar: '//qnm.hunliji.com/o_1djt4ninu1ep71gh16r81lbi1fjja.png',
    tabSelectedBg:
      'linear-gradient(152deg,rgba(255,91,106,1) 0%,rgba(248,50,68,1) 100%)',
    tabBg: '#FFF3F5',
    tabSelectedText: '#fff',
    tabText: '#333',
    editText: '#578AFF',
    shopInfoBoxBg: '#fff',
    dynamicBg: 'linear-gradient(180deg, #ffffff 0%, #f2f3f6 10%, #f2f3f6 100%)'
  },
  [THEME_WHITE_GOLD]: {
    darkestText: '#000',
    darkerText: '#333',
    text: '#666',
    moduleTitle: '#000',
    splitLine: '#e2e2e2',
    themeColor: '#E8B45E',
    moduleBg: BLOCK_BG_COLOR,
    honorIcon: '//qnm.hunliji.com/o_1cnjk7amg19c4r041epb8vpvrf.png',
    defaultStar: '//qnm.hunliji.com/o_1djrlk66r9ct10kolju1caa8k9.png',
    coverStar: '//qnm.hunliji.com/o_1djt4ninu1vbsut5721g4g1937b.png',
    tabSelectedBg:
      'linear-gradient(152deg,rgba(232,180,94,1) 0%,rgba(224,171,84,1) 100%)',
    tabBg: '#FFF8ED',
    tabSelectedText: '#fff',
    tabText: '#666',
    editText: '#578AFF',
    shopInfoBoxBg: '#fff',
    dynamicBg: 'linear-gradient(180deg, #ffffff 0%, #f2f3f6 10%, #f2f3f6 100%)'
  },
  [THEME_BLACK_GOLD]: {
    darkestText: '#D5C8B4',
    darkerText: '#D5C8B4',
    text: '#D5C8B4',
    moduleTitle: '#E8B45E',
    splitLine: '#3E3D3A',
    themeColor: '#E8B45E',
    moduleBg: BLOCK_BG_BLACK_GOLD_COLOR,
    honorIcon: '//qnm.hunliji.com/o_1cnjk7amg19c4r041epb8vpvrf.png',
    defaultStar: '//qnm.hunliji.com/o_1djrlutql1oc729413c3job1bnbe.png',
    coverStar: '//qnm.hunliji.com/o_1djt4ninu1vbsut5721g4g1937b.png',
    tabSelectedBg:
      'linear-gradient(152deg,rgba(232,180,94,1) 0%,rgba(224,171,84,1) 100%)',
    tabBg: '#FFF8ED',
    tabSelectedText: '#fff',
    tabText: '#666',
    editText: '#E8B45E',
    shopInfoBoxBg: '#2D2C2A',
    dynamicBg: '#2D2C2A'
  },
  [THEME_TOP_WEDDING]: {
    // 这个和黑金一样
    darkestText: '#D5C8B4',
    darkerText: '#D5C8B4',
    text: '#D5C8B4',
    moduleTitle: '#E8B45E',
    splitLine: '#3E3D3A',
    themeColor: '#E8B45E',
    moduleBg: BLOCK_BG_BLACK_GOLD_COLOR,
    honorIcon: '//qnm.hunliji.com/o_1cnjk7amg19c4r041epb8vpvrf.png',
    defaultStar: '//qnm.hunliji.com/o_1djrlutql1oc729413c3job1bnbe.png',
    coverStar: '//qnm.hunliji.com/o_1djt4ninu1vbsut5721g4g1937b.png',
    dynamicBg: '#2D2C2A'
  },
  [THEME_WHITE_GREEN]: {
    moduleTitle: '#000',
    themeColor: THEME_GREEN_COLOR,
    moduleBg: BLOCK_BG_COLOR,
    honorIcon: '//qnm.hunliji.com/o_1cnjk7amg1r1q1vhoaf11brjd75h.png',
    defaultStar: '//qnm.hunliji.com/o_1djrlk66r9ct10kolju1caa8k9.png',
    coverStar: '//qnm.hunliji.com/o_1djt4ninu1ep71gh16r81lbi1fjja.png',
    dynamicBg: 'linear-gradient(180deg, #ffffff 0%, #f2f3f6 10%, #f2f3f6 100%)'
  },
  [THEME_WHITE_BLUE]: {
    moduleTitle: '#000',
    themeColor: THEME_BLUE_COLOR,
    moduleBg: BLOCK_BG_COLOR,
    honorIcon: '//qnm.hunliji.com/o_1cnjk7amg1sbjebs18mgg9c1j7dg.png',
    defaultStar: '//qnm.hunliji.com/o_1djrlk66r9ct10kolju1caa8k9.png',
    coverStar: '//qnm.hunliji.com/o_1djt4ninu1ep71gh16r81lbi1fjja.png',
    dynamicBg: 'linear-gradient(180deg, #ffffff 0%, #f2f3f6 10%, #f2f3f6 100%)'
  },
  [THEME_WHITE_PINK]: {
    moduleTitle: '#000',
    themeColor: THEME_PINK_COLOR,
    moduleBg: BLOCK_BG_COLOR,
    honorIcon: '//qnm.hunliji.com/o_1cnjk7amg1ubuqh81sko1m81sije.png',
    defaultStar: '//qnm.hunliji.com/o_1djrlk66r9ct10kolju1caa8k9.png',
    coverStar: '//qnm.hunliji.com/o_1djt4ninu1ep71gh16r81lbi1fjja.png',
    dynamicBg: 'linear-gradient(180deg, #ffffff 0%, #f2f3f6 10%, #f2f3f6 100%)'
  }
}
